import { createMemo, For, Show } from "solid-js";
import { runsOf } from "../lib/catalog-search.ts";
import styles from "./Highlight.module.scss";

/**
 * A title with the characters a search hit wrapped in a mark. Without indexes
 * it renders the text as one node, so a tree that is not being searched reads
 * exactly as before.
 */
export const Highlight = (props: {
	text: string;
	indexes?: readonly number[];
}) => {
	const runs = createMemo(() => runsOf(props.text, props.indexes ?? []));

	return (
		<Show when={props.indexes !== undefined} fallback={props.text}>
			<For each={runs()}>
				{(run) => (
					<Show when={run.hit} fallback={run.text}>
						<mark class={styles.mark}>{run.text}</mark>
					</Show>
				)}
			</For>
		</Show>
	);
};
